<template>
  <div>
    <Row>
      <Col span="22">
        <div class="container_wang_company">
          <Form ref="formCustom" :model="formCustom" :rules="ruleCustom">
            <table>
              <tr>
                <td class="title" colspan="2">密码修改</td>
              </tr>
              <tr>
                <td>原密码</td>
                <td>
                    <Input type="password" v-model="formCustom.password"/>
                </td>
              </tr>
              <tr>
                <td>新密码</td>
                <td>
                  <FormItem prop="passwordNew">
                    <Input type="password" v-model="formCustom.passwordNew"/>
                  </FormItem>
                </td>
              </tr>
              <tr>
                <td>再次输入新密码</td>
                <td>
                  <FormItem prop="passwordCheck">
                    <Input type="password" v-model="formCustom.passwordCheck"/>
                  </FormItem>
                </td>
              </tr>
            </table>
          </Form>
          <my-button @confirm="edit">修改</my-button>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
  import ApiClient from "@/api/ApiClient";
  import MyButton from '@/components/MyButton'
  export default {
    name: "resetPassword",
    components: {
      MyButton,
    },
    data() {
      const passwordNew = (rule, value, callback) => {
        let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
        let res = reg.test(value);
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (!res) {
            callback(new Error('请输入6-20位数字和字母组合的密码'));
          } else {
            if (this.formCustom.passwordCheck !== '') {
              // 对第二个密码框单独验证
              this.$refs.formCustom.validateField('passwordCheck');
            }
          }
          callback();
        }
      };
      const validatePassCheck = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.formCustom.passwordNew) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        formCustom: {
          user: '',
          passwordNew: '',
          passwordCheck: '',
        },
        ruleCustom: {
          passwordNew: [
            {validator: passwordNew, trigger: 'blur'}
          ],
          passwordCheck: [
            {validator: validatePassCheck, trigger: 'blur'}
          ],
        }
      }
    },
    methods: {
      edit() {
        this.$refs.formCustom.validate((valid) => {
          if (valid) {
            ApiClient.put('/desktop/customer/password.do', this.formCustom).then(data => {
              window.sessionStorage.removeItem('currentUser');
              setTimeout(() => {
                this.$router.push({name: 'login'});
              }, 3000);

            })
          } else {
            this.$Message.error('请完善信息');
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .title {
    font-weight: 700;
  }
  table {
    border-collapse: collapse;
    margin-left: 60px;
    margin-top: 16px;
    width: 100%;
    tr td {
      border: 1px solid #D8D8D8;
      height: 42px;
      padding-left: 20px;
    }
    tr td:nth-child(2n+1) {
      width: 17%;
    }
    tr td:nth-child(2n) {
      width: 57%;
    }
  }

  table tr:nth-child(1), table tr:nth-child(3), table tr:nth-child(5), table tr:nth-child(7) {
    background-color: #F6F6F5;
  }

</style>

<style lang="less">
  .container_wang_company .ivu-input {
    width: 50%;
    margin-left: -10px;
  }

  .container_wang_company button {
    margin-left: 46%;
    margin-top: 60px;
  }

  .container_wang_company .ivu-form-item {
    margin-bottom: 0;
  }

  .container_wang_company .ivu-form-inline .ivu-form-item {
    width: 100%;
  }

  .container_wang_company .ivu-form-item-error-tip {
    display: inline;
    position: static;
  }

  .container_wang_company .ivu-input-wrapper {
    width: auto;
    display: inline;
  }

</style>



// WEBPACK FOOTER //
// src/pages/myProfile/resetPassword.vue